import { useState, useEffect } from "react";
import TextInput from "../../../components/TextInput";
import Swal from "sweetalert2";
import CancelButton from "../../../components/CancelButton";
import { addLobType } from "../../../actions/Utilities/LobType";
import { useQueryClient } from "react-query";
import TableNoBorder from "../../../components/tables/TableNoBorder";
import Button from "../../../components/Button";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import ConfirmBoxModal from "../../../components/ConfirmBoxModal";

const AddLOBTypeForm = ({ lobTypeData, Cancel }) => {
  const addLOBType = {
    isActive: true,
    lobName: "",
    lobCode: "",
    modifiedBy: "",
  };
  const [addLOBData, setaddLOBData] = useState([addLOBType]);
  const [lobcodeExist, setLOBCodeExist] = useState(false);
  const [lobDataChanged, setlobDataChanged] = useState(false);
  const [openModal, setopenModal] = useState(false);
  const [hasLobCode, setHasLobCode] = useState(false);

  const queryClient = useQueryClient();
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  useEffect(() => {
    setLOBCodeExist(false);
    setlobDataChanged(false);
  }, []);

  const handleCheckBox = (e) => {
    const checked = e.target.checked;
    setlobDataChanged(true);
    if (checked) {
      //checked
      addLOBData[0].isActive = true;
    } else {
      //unchecked
      addLOBData[0].isActive = false;
    }
  };

  const handleaddFieldsChange = (SourceType, fieldName, row, inputvalue) => {
    setlobDataChanged(true);
    if (SourceType === "addLOBType") {
      if (fieldName === "LOBName") {
        addLOBData[0].lobName = inputvalue;
      }
      if (fieldName === "LOBCode") {
        const result = lobTypeData.filter(
          (item) => item.lobcode.toUpperCase() === inputvalue.toUpperCase()
        )[0];
        addLOBData[0].lobCode = inputvalue;
        if (result !== undefined) {
          setLOBCodeExist(true);
        } else {
          setLOBCodeExist(false);
        }
      }
      addLOBData[0].lobCode !== "" ? setHasLobCode(true) : setHasLobCode(false);
    }
  };

  const handleSave = (addLOBData) => {
    if (lobDataChanged) {
      if (!lobcodeExist) {
        if (addLOBData.lobName !== "" && addLOBData.lobCode !== "") {
          addLobType(addLOBData)
            .then((res) => {
              queryClient.invalidateQueries(["LobType"]);
              Toast.fire("Success", "LOB Type Added Successfully", "success");
              Cancel(false);
              setLOBCodeExist(false);
              setlobDataChanged(false);
              setopenModal(false);
            })
            .catch((err) => {
              Toast.fire(
                "Error",
                "Failed to Add Line of Business Type",
                "error"
              );
              setopenModal(false);
            });
        } else {
          Toast.fire("Saving Failed", "All fields must be filled!", "error");
          setopenModal(false);
        }
      } else {
        Toast.fire("Saving Failed", "Data Already Exist", "error");
        setopenModal(false);
      }

      // end of saving changes
    } else {
      Toast.fire("Saving Failed", "No Changes have been made", "warning");
      setopenModal(false);
    }
  };

  const columns = [
    {
      name: "LOB Name",
      cell: (row) => {
        return (
          <div className="w-52 mr-2">
            <TextInput
              placeholder="LOB Name"
              defaultValue={row.lobName}
              onChange={(inputdata) => {
                handleaddFieldsChange(
                  "addLOBType",
                  "LOBName",
                  row,
                  inputdata.target.value
                );
              }}
            />
          </div>
        );
      },
      sortable: true,
    },

    {
      name: "LOB Code",
      cell: (row) => {
        return (
          <div className="w-52 mr-2">
            <TextInput
              placeholder="LOB Code"
              defaultValue={row.lobCode}
              onChange={(inputdata) => {
                handleaddFieldsChange(
                  "addLOBType",
                  "LOBCode",
                  row,
                  inputdata.target.value
                );
              }}
            />
          </div>
        );
      },
      sortable: true,
      center: true,
    },
    // {
    //   name: "Status",

    //   cell: (row) => {
    //     return (
    //       <div className="flex items-center space-x-1 cursor-pointer">
    //         <input
    //           type="checkbox"
    //           className="flex items-center space-x-1 cursor-pointer"
    //           defaultChecked={state === "" ? row.isActive : state}
    //           onClick={(e) => {
    //             //  clickcode
    //             setState(e.target.checked);
    //             handleCheckBox(e);
    //           }}
    //         />

    //         <label className="cursor-pointer text-green-600" name="Status">
    //           {row.isActive ? "Un-Check to Deactive!" : "Check to Activate"}
    //         </label>
    //       </div>
    //     );
    //   },
    //   sortable: true,
    //   center: true,
    // },

    {
      name: "Actions",
      center: true,
      cell: (row) => (
        <div className="flex items-center justify-center space-x-2 w-full mr-2">
          <Button
            className={`flex items-center shadow-md text-xs font-semibold text-white justify-center gap-x-1 rounded-full ml-auto bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
            ${!hasLobCode ? "opacity-50" : "opactiy-100"}`}
            disabled={!hasLobCode}
            onClickFunction={() => setopenModal(true)}
          >
            <CheckCircleIcon className="h-4 w-4" />
            <div>Save</div>
          </Button>
          <CancelButton onClick={() => Cancel(false)} />
        </div>
      ),
      button: true,
      grow: 2,
      width: "200px",
    },
  ];

  return (
    <div className="w-full">
      <ConfirmBoxModal
        ModalTitle="Add LOB"
        qConfirmation=" Are you sure you want to add this?"
        isOpen={openModal}
        onClose={() => setopenModal(false)}
        onClickFunction={() => {
          handleSave(addLOBData[0]);
        }}
      />
      <div className=" px-3 py-3 border-l-2  border-primary box-shadow">
        <div className="text-base text-primary font-bold -mt-3">
          Add LOB Type
        </div>

        <div className="mt-2 h-0.5 w-full border-b-2 border-secondary "></div>

        <div className="py-3"></div>

        <div className="space-y-5 space-x-2 space-y-20 w-full  ">
          <TableNoBorder
            columns={columns}
            data={addLOBData}
            progressPending={false}
            pagination={false}
          />
        </div>
      </div>
      <div className="hidden sm:block" aria-hidden="true">
        <div className="py-5"></div>
      </div>
    </div>
  );
};

export default AddLOBTypeForm;
